<div [formGroup]="group">
  <app-formelementinputlabel [config]="config" [group]="group"></app-formelementinputlabel>
  <app-inner-bool [formControlName]="config.name" [config]="config" [group]="group" #formInput></app-inner-bool>
  <app-formelementinputdescription [config]="config" [group]="group"></app-formelementinputdescription>
  <app-formelementinput-validationmessages [config]="config" [group]="group"></app-formelementinput-validationmessages>
</div>

